module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagsFilter":"Tags filter","and":"And","addAGroup":"Add a tag group"},"fr":{"tagsFilter":"Filtre de tag","and":"Et","addAGroup":"Ajouter un groupe de tag"},"de":{"tagsFilter":"Filtre de tag","and":"Und","addAGroup":"Fügen Sie eine Tag-Gruppe hinzu"}}')
  delete Component.options._Ctor
}
